// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface SectionCardProps {
  title?: string;
  /** Small decorative mark rendered before the title (e.g. a vendor/agent logo). */
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerBar?: boolean;
  /** Scopes queries to one card when a page repeats a badge or a value. */
  testId?: string;
}

export function SectionCard({
  title,
  icon,
  badge,
  children,
  className,
  headerBar,
  testId,
}: SectionCardProps) {
  if (headerBar) {
    return (
      <div
        className={cn('rounded-gl-lg border border-border bg-card overflow-hidden', className)}
        data-testid={testId}
      >
        <div className="flex items-center justify-between gap-3 px-5 h-12 bg-muted/40 border-b border-border">
          <div className="flex min-w-0 items-center gap-2">
            {icon}
            {title && <h2 className="text-[13.5px] font-bold text-foreground">{title}</h2>}
          </div>
          {badge && <div className="shrink-0">{badge}</div>}
        </div>
        <div>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={cn('rounded-gl-lg border border-border bg-card p-4 md:p-5', className)}
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          {icon}
          {title && <h2 className="text-sm font-semibold text-foreground">{title}</h2>}
        </div>
        {badge && <div className="shrink-0">{badge}</div>}
      </div>
      <div className="mt-3">{children}</div>
    </div>
  );
}
